import { constantStrings } from '@/services/constants'
import Storage from '../services/storageLib'
import VoiceState from '../services/voiceConstants'

function DefaultState() {
  this.calloutBubblePubsubConfig = {}
  this.supportIconState = {
    visible: true
  }
  this.termsAndConditions = {
    terms: {},
    triggerGreeting: '',
    quickReply: null
  }
  this.alerts = {
    highPriorityAlert: {},
    mediumPriorityAlert: {},
    triggerGreeting: ''
  }
  this.blankScreen = {
    timerId: null
  }
  this.csat = {
    isEnabled: false,
    rating: null,
    comment: '',
    thumbUpType: 'ThumbUp',
    thumbDownType: 'ThumbDown',
    rateLimit: {
      limitLeft:
        Storage.getLocalStorageData(constantStrings.CSAT_RATE_LIMIT_STATE) !==
        null
          ? Storage.getLocalStorageData(constantStrings.CSAT_RATE_LIMIT_STATE)
              ?.limitLeft
          : constantStrings.CSAT_RATE_LIMIT,
      timerId: null
    }
  }
  this.deviceDetails = {
    userAgent: navigator?.userAgent
  }
  this.formInputMaskedValue = {}
  this.externalId = ''
  this.previousConversationId = ''
  this.previousCoversationLoader = false
  this.isfullHistoryLoaded = false
  this.currentCoversationId = ''
  this.previousTimestamp = null
  this.cookieValuesCopy = {}
  this.fallbackMechanismState = {
    isVisible: false,
    retryTimerId: '',
    retryLeft: 0
  }
  this.botDetails = {
    timezone: '', // currently used only for zendesk agentdesk transcript,
    properties: {}
  }
  this.botRefId = ''
  this.widgetId = ''
  this.user = {
    id: '',
    email: ''
  }
  this.knowledgeAISourcesState = {
    isEnabled: false,
    multiSources: {
      sources: [],
      multiSourceText: ''
    }
  }
  this.isAuth = false
  this.isFileAttachmentIconDisabled = false
  this.inputFieldDisableStatus = null
  this.inputFieldTempDisableStatus = null
  this.inputFieldHiddenStatus = null
  this.endChatCustomFieldStatus = false
  this.primaryLanguage = 'ENGLISH'
  this.formControlsButtonState = {
    backEnabled: false,
    restartEnabled: false,
    skipEnabled: false,
    currentFormRequestId: ''
  }
  this.clearConversationState = {
    clearConversation: false,
    status: ''
  }
  this.formSubmissionStatus = {
    status: '',
    text: '',
    formName: '',
    loader: false
  }
  this.eventAnalyticsMP = false
  this.isTriggerMinimizeValid = false
  this.userMessage = ''
  this.visitorDisplayNameForAgentDesk = ''
  this.controlType =
    Storage.getLocalStorageData('controlType') || constantStrings.BOT
  this.agentInfo = Storage.getLocalStorageData('agentInfo') || {}
  this.customHandoffDepartment = ''
  this.visitorInfo = {}
  this.showFormControls = false
  this.formControlsClicked = false
  this.formControlsClickedMessageId = 0
  this.isWindowMaximized = false
  this.isChatWidgetFullScreen = false
  this.chats = []
  this.previousChats = []
  this.messageTags = []
  this.quickReplyOptions = []
  this.actionableNBAOptions = []
  this.nonActionableNBAOptions = []
  this.nonActionableNBAOverlayEnabled = false
  this.widgetConfig = {}
  this.browserFontSizeSetting = 'medium'
  this.showTypingIndicator = false
  this.isHistoryLoading = false
  this.showEndChatFlow = {
    enableWidget: false,
    timerId: null,
    isChatRestart: false
  }
  this.isOverlayActive = false
  this.overlayTimerId = null
  this.schemaFormLabels = {}
  this.isCalloutBubbleEnabled = false
  this.userMessageSyncAcrossTabs = true
  this.currentScopedFormID = ''
  this.widgetStatus = {
    status: ''
  }
  this.authToken = ''
  this.formsSubmittedInfo = {}
  this.widgetVisitorInfo = {}
  this.authenticatedConversationId = ''
  this.defaultAttributes = []
  this.notificationSound = false
  this.agentDeskConnectionStatus = ''
  this.connectionStatus = true
  this.isMqttConnected = false
  this.isCalloutBubbleLoaded = false
  this.typingIndicatorTimeoutPromise = ''
  this.preLoaderEnabled = true
  this.quickMenuState = {
    visible: false,
    title: '',
    options: []
  }
  this.headerDrawerState = {
    show: false
  }
  this.formSkipInfo = {}
  this.quickMenuClickHandler = function () {}
  this.defaultLocale = 'en'
  this.userIPAddress = ''
  this.surveyRule = {
    isPresent: false,
    idleTimeoutRule: {
      rule: {},
      timerId: null
    },
    endChatRule: {
      rule: {}
    },
    sessionTimeoutRule: {
      rule: {}
    }
  }
  this.focusNode = null
  this.focusEnable = false
  this.unreadMessagesState =
    Storage.getLocalStorageData(constantStrings.UNREAD_MESSAGES_STATE) || false
  this.inputFieldTempDisableStatusTimer = ''
  this.inputFieldOnSendDisableTimer = ''
  this.agentDesk = {
    idleTimeoutTimerId: null
  }
  this.surveyFormState = {
    isValid: false,
    data: {},
    isFirstResponse: false,
    isSurveySubmitted: false,
    submittedValues: {}
  }
  this.formEncryptionPublicKey = ''
  this.botPCIPolicy = {}
  this.maskedValueMap = {}
  this.inputFieldStreamingDisableStatus = false
  this.footer = {
    disableInputOnSend: {
      state: false,
      reEnableTimeout: ''
    }
  }
  this.multiSourceLogoObj = {}
  this.showExternalHeaderText = {
    active: false,
    text: '',
    showPopoverInfoIcon: false
  }
  this.showHeaderMenuButtons = true
  this.promptTestDetails = {
    active: false,
    passCustomAttribtes: false,
    isResponseAnalyzerWidget: false
  }
  this.isLastChunkPlayed = false
  this.isVoiceModeActive = false
  this.currentVoiceState = VoiceState.NONE
  this.shouldRestartVoiceRecording = true
  this.csatSurveyStartTime = undefined
  this.showVisitorInfoButton = false
  this.visitorInfoForm = {
    isOpen: false,
    visitorInfoDetails: ''
  }
  this.lastMessageLocale = 'en'
  this.ttsToken = null
  this.termsAndConditionsAccepted = false
  this.progressiveTypingIndicatorConfig = [
    { duration: 2000, text: '' },
    { duration: 3000, text: 'Looking into that now...' },
    { duration: 5000, text: 'Gathering relevant information...' },
    { duration: 20000, text: 'Almost there, just wrapping it up' }
  ]
  this.clientConfigs = {
    endChat: {}
  }
  this.incognitoModeData = {
    localStorage: {},
    sessionStorage: {}
  }
  this.featureFlagList = {}
}

export default DefaultState
